<template>
  <div>
    <tableComponent
      class="pa-5 pl-0"
      ref="tableComponent"
      :tableSettings="tableSettings"
      :tableData="tableData"
      :headers="headers"
      :enable-row-clickable="true"
      @newDocument="newDocument"
      @clickedRow="openDetails($event)"
      @openBulkTagDialog="openBulkTagDialog"
      @confirmBulkDelete="confirmBulkDelete"
    />
    <employeeBulkTagDialog ref="bulkTagDialog" @applied="onBulkActionDone" />
    <employeeDetailsDialog
      ref="employeeDetailsDialog"
      v-model="isEmployeeDialogOpen"
    />
    <v-dialog v-model="bulkConfirm.open" max-width="440">
      <v-card>
        <v-card-title>{{ bulkConfirm.title }}</v-card-title>
        <v-card-text>{{ bulkConfirm.message }}</v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            @click="bulkConfirm.open = false"
            :disabled="bulkConfirm.loading"
          >
            {{ $t("general.cancel") }}
          </v-btn>
          <v-btn
            :color="bulkConfirm.color"
            :loading="bulkConfirm.loading"
            @click="runBulkConfirm"
          >
            {{ bulkConfirm.confirmText }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { getUniqueId } from "@/components/api/api";
import tableComponent from "@/components/_utils/dataTableHelpers/tableComponent.vue";
import employeeDetailsDialog from "../../components/tableSlotComponents/employee/employeeDetailsDialog.vue";
import employeeBulkTagDialog from "../../components/tableSlotComponents/employee/employeeBulkTagDialog.vue";

export default {
  components: {
    tableComponent,
    employeeDetailsDialog,
    employeeBulkTagDialog,
  },
  data: () => ({
    tableSettings: {
      title: "",
      showSelect: true,
      showHeaderToolbar: true,
      headerButtons: [
        {
          title: "employee.external.add",
          color: "secondary",
          action: "newDocument",
          icon: "add",
          iconDark: true,
          dark: true,
          outlined: true,
        },
      ],
      multipleSelectButtons: [
        {
          title: "employee.tags.bulkButton",
          color: "primary",
          action: "openBulkTagDialog",
          icon: "mdi-tag-multiple",
          iconDark: true,
          dark: true,
          outlined: true,
        },
        {
          title: "employee.bulk.deleteButton",
          color: "error",
          action: "confirmBulkDelete",
          icon: "delete",
          iconDark: true,
          dark: true,
          outlined: true,
        },
      ],
    },
    tableData: {
      tableComponentSlots: [
        {
          id: getUniqueId(),
          slotName: "item.employeeAction",
          componentName: "employeeAction",
        },
        {
          id: getUniqueId(),
          slotName: "item.employeeTags",
          componentName: "employeeTagsColumn",
        },
      ],
      itemKey: "_id",
      uriPartPrepend: "employee",
      uriPartAppend: "&external=true",
      populate: ["tags"],
      sort: "",
      editFormPushName: "employeeForm",
    },
    isEmployeeDialogOpen: false,
    bulkConfirm: {
      open: false,
      loading: false,
      title: "",
      message: "",
      confirmText: "",
      color: "primary",
      action: null,
      ids: [],
    },
  }),
  computed: {
    headers() {
      return [
        {
          text: this.$t("employee.tableHeader.name"),
          value: "name",
          align: "left",
        },
        { text: this.$t("employee.tableHeader.email"), value: "email" },
        {
          text: this.$t("employee.tableHeader.language"),
          value: "employeeLanguage",
        },
        {
          text: this.$t("employee.tableHeader.tags"),
          value: "employeeTags",
        },
        {
          text: "",
          value: "employeeAction",
          align: "center",
          sortable: false,
        },
      ];
    },
  },
  methods: {
    reloadDataFunc() {
      this.$refs.tableComponent.getData();
    },
    newDocument() {
      this.$router.push({
        name: this.tableData.editFormPushName,
        params: { id: "1", mode: "new", data: 1 },
        query: { external: "1" },
      });
    },
    openDetails(employee) {
      this.$refs.employeeDetailsDialog.data = employee;
      this.isEmployeeDialogOpen = true;
    },
    openBulkTagDialog(selectedItems) {
      this.$refs.bulkTagDialog.open(selectedItems || []);
    },
    confirmBulkDelete(selectedItems) {
      const ids = (selectedItems || []).map((e) => e._id);
      this.bulkConfirm = {
        open: true,
        loading: false,
        title: this.$t("employee.bulk.deleteTitle"),
        message: this.$t("employee.bulk.deleteConfirm", { count: ids.length }),
        confirmText: this.$t("employee.bulk.deleteButton"),
        color: "error",
        action: "bulkDeleteEmployees",
        ids,
      };
    },
    async runBulkConfirm() {
      this.bulkConfirm.loading = true;
      try {
        await this.$store.dispatch(
          this.bulkConfirm.action,
          this.bulkConfirm.ids,
        );
        this.bulkConfirm.open = false;
        this.onBulkActionDone();
      } finally {
        this.bulkConfirm.loading = false;
      }
    },
    onBulkActionDone() {
      if (this.$refs.tableComponent) {
        this.$refs.tableComponent.clearSelectItems();
      }
      this.reloadDataFunc();
    },
  },
};
</script>
